export default "__VITE_ASSET__DsPI9F5j__"